import { render } from "./FundInvestment.vue?vue&type=template&id=6514a92e"
import script from "./FundInvestment.vue?vue&type=script&lang=js"
export * from "./FundInvestment.vue?vue&type=script&lang=js"

import "./FundInvestment.vue?vue&type=style&index=0&id=6514a92e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__